import { object, array, string } from '@gogame/schemas';

export const columnsSchema = object({
  order: array(string()).default([
    '1',
    '4',
    '9',
    '10',
    '13',
    '17',
    '20',
    '25',
    '26',
    '27',
    '28',
    '36',
    '37',
    '38',
    '39',
  ]),
  collapsed: array(string()).default([]),
});
